const initializeSpHoverDesc = () => {
  document.querySelectorAll('.jsSpHoverDesc').forEach(hoverDesc => {
    hoverDesc.addEventListener('click', (e) => {
      // NOTE: リンククリック時はアクションしない
      if (e.target.closest('a')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const tooltip = hoverDesc.querySelector('span');

      if (hoverDesc.classList.contains('active')) {
        hoverDesc.classList.remove('active');
        return;
      }

      document.querySelectorAll('.jsSpHoverDesc').forEach(other => {
        other.classList.remove('active');
      });

      hoverDesc.classList.add('active');

      const parent = hoverDesc.closest('.jsHoverDescContainer');
      const iconRect = hoverDesc.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();

      const tooltipWidth = parentRect.width - 20;
      const targetTooltipGlobalLeft = parentRect.left + 10;
      const cssLeftForTooltip = targetTooltipGlobalLeft - iconRect.left;

      tooltip.style.left = `${cssLeftForTooltip}px`;
      tooltip.style.width = `${tooltipWidth}px`;
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.jsSpHoverDesc')) {
      document.querySelectorAll('.jsSpHoverDesc').forEach(hoverDesc => {
        hoverDesc.classList.remove('active');
      });
    }
  });
};

export default initializeSpHoverDesc;
